module.exports = __webpack_public_path__ + "img/A_logo.464abfb0.png";